<template>
  <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
    <el-tab-pane label="意见反馈列表" name="first">
      <div class="main">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-input v-model="queryData.opinion"  placeholder="请输入问题"></el-input>
              <el-input v-model="queryData.feedback"  placeholder="请输入回答"></el-input>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
            <el-table-column prop="userid" label="用户编号" sortable="custom"></el-table-column>
            <el-table-column prop="opinion" label="意见" sortable="custom"></el-table-column>
            <el-table-column prop="feedback" label="反馈" sortable="custom"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            <el-table-column prop="Operation" label="操作" width="100">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(scope.row)"></el-link>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->

        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
          <div class="addUser_body">
            <el-form ref="userMsg" :model="editData" label-width="80px">
              <el-form-item label="意见" :required=true>
                <el-input v-model="editData.opinion" placeholder="请输入意见" disabled></el-input>
              </el-form-item>
              <el-form-item label="反馈" :required=true>
                <el-input v-model="editData.feedback" placeholder="请输入反馈"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="FeedbackUpdate()" >确 认</el-button>
            <el-button @click="dialogEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->

      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: { },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        opinion: '',
        feedback: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        opinion: '',
        feedback: ''
      }
    }
  },
  mounted () {
    this.FeedbackList()
    this.FeedbackNum()
  },
  methods: {
    handleSizeChange (val) {
      this.page_size = val
      this.FeedbackList()
      this.FeedbackNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.FeedbackList()
      this.FeedbackNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.FeedbackList()
      this.FeedbackNum()
    },
    clickQuery () {
      this.page_no = 1
      this.FeedbackList()
      this.FeedbackNum()
    },
    clickQueryReset () {
      this.queryData.opinion = ''
      this.queryData.feedback = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.opinion = row.opinion
      this.editData.feedback = row.feedback
    },
    FeedbackList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.opinion = that.queryData.opinion
      data.feedback = that.queryData.feedback
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_FeedbackList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    FeedbackNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.opinion = that.queryData.opinion
      data.feedback = that.queryData.feedback
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_FeedbackNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    FeedbackUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.feedback = that.editData.feedback
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_FeedbackUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.FeedbackList()
            that.FeedbackNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
